import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchAreaTypeHistory } from './queries/useFetchAreaTypeHistory'

const AreaTypeHistory = () => {
	const { t } = useTranslation()

	const { boothTypeHistory, isLoading } = useFetchAreaTypeHistory()

	return (
		<>
			<Header title={t('Area type / History')} />
			<HistoryTable results={boothTypeHistory?.data} isLoading={isLoading} />
		</>
	)
}

export default AreaTypeHistory
